import { render, staticRenderFns } from "./homedisinfector.vue?vue&type=template&id=03cf24d0&scoped=true&"
import script from "./homedisinfector.vue?vue&type=script&lang=js&"
export * from "./homedisinfector.vue?vue&type=script&lang=js&"
import style0 from "./homedisinfector.vue?vue&type=style&index=0&id=03cf24d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cf24d0",
  null
  
)

export default component.exports